import { ConsumptionModeType } from '@innovorder/order_detail';
import { ProductAttributesFromCategories, HashMappedStepProduct } from 'services/menu/menu.type';
import { MenuState } from 'state/menu';
import { isConsumptionFlagActivated } from 'utils/consumptionFlags';

const stepProductsWebAvailabilityCheck = (
    product: ProductAttributesFromCategories,
    menu: MenuState | null,
    currentConsumptionModeType: ConsumptionModeType | null,
): boolean => {
    if (!menu?.products?.[product.productId]?.productStep?.length) {
        return true;
    }

    const productWithRelations = menu.products[product.productId];
    const steps = productWithRelations.productStep;

    return steps.every((step) => {
        if (step.minChoice === 0) {
            return true;
        }
        const stepProducts = menu.steps?.[step.stepId]?.stepProduct;

        if (!step.webAvailability || !stepProducts?.length) {
            return false;
        }

        return stepProducts.some((stepProduct: HashMappedStepProduct) => {
            const stepProductData = menu.products?.[stepProduct.productId];
            if (!stepProductData) {
                return false;
            }

            return (
                stepProductData.webAvailability &&
                stepProductData.currentQuantity !== 0 &&
                isConsumptionFlagActivated(
                    stepProductData.consumptionFlags,
                    currentConsumptionModeType,
                )
            );
        });
    });
};

export const computeProductList = (
    productList: ProductAttributesFromCategories[],
    currentConsumptionModeType: ConsumptionModeType | null,
    menu: MenuState | null,
    isProductDisplayedWhenUnavailable?: boolean,
): ProductAttributesFromCategories[] => {
    return productList
        .filter(({ webAvailability }) => !!webAvailability)
        .filter(({ currentQuantity }) =>
            isProductDisplayedWhenUnavailable ? true : currentQuantity !== 0,
        )
        .filter(({ consumptionFlags }) =>
            isConsumptionFlagActivated(consumptionFlags, currentConsumptionModeType),
        )
        .filter((product) =>
            stepProductsWebAvailabilityCheck(product, menu, currentConsumptionModeType),
        )
        .sort(
            (
                { category_product: { position: positionA } },
                { category_product: { position: positionB } },
            ) => positionA - positionB,
        );
};
